<nav>
  <ul class="breadcrumb">
    <li class="ms-auto"><a routerLink="/site-admin"><i class="fa fa-globe" style="width: 20px;"></i>Site Security Management</a></li>
  </ul>
</nav>
<div class="d-flex justify-content-center align-items-center">
  <h1 class="me-2">Agency Security Management</h1>
</div>
@for (error of errors; track error) {
  <div class="col-12 col-lg-6 offset-lg-3">
    <ngb-alert type="danger" (close)="closeError(error)">{{ error }}</ngb-alert>
  </div>
}
<form [formGroup]="agencyAdminForm">
  <div class="row">
    <div class="py-2 py-sm-4 col-12 col-sm-4">
      <label for="application">Application:</label>
      @if (applications && applications.length == 1) {
        <input type="text" id="applicationTextbox" formControlName="applicationTextbox" readonly="readonly" class="form-control" labelForId="application" />
      }
      @if (applications && applications.length > 1) {
        <select id="application" formControlName="application" class="form-select" labelForId="application" (change)="onApplicationChange()">
          @for (application of applications; track application) {
            <option [ngValue]="application.id">{{ application.name }}</option>
          }
        </select>
      }
    </div>
    <div class="py-2 py-sm-4 col-12 col-sm-4">
      <label for="agency-type">Agency Type:</label>
      @if (agencyTypes && agencyTypes.length == 1) {
        <input type="text" id="agencyTypeTextbox" formControlName="agencyTypeTextbox" readonly="readonly" class="form-control" labelForId="agency-type" />
      }
      @if (agencyTypes && agencyTypes.length > 1) {
        <select id="agency-type" formControlName="agencyType" class="form-select" labelForId="agency-type" (change)="onAgencyTypeChange()">
          @for (agencyType of agencyTypes; track agencyType) {
            <option [ngValue]="agencyType.id">{{ agencyType.name }}</option>
          }
        </select>
      }
    </div>
    <div class="py-2 py-sm-4 col-12 col-sm-4">
      <label for="agency">Agency:</label>
      @if (agencies && agencies.length == 1) {
        <input type="text" id="agencyTextbox" formControlName="agencyTextbox" readonly="readonly" class="form-control" labelForId="agency" />
      }
      @if (agencies && agencies.length > 1) {
        <select id="agency" formControlName="agency" class="form-select" labelForId="agency" (change)="onAgencyChange()">
          @for (agency of agencies; track agency) {
            <option [ngValue]="agency.id">{{ agency.name }}</option>
          }
        </select>
      }
    </div>
  </div>
  <div class="row">
    <div class="table-caption col-10">Users: @if (userHelpMessage) {
      <i class="fa fa-question-circle" [ngbTooltip]="userHelpMessage"></i>
    }</div>
    <div class="text-end col-2"><button (click)="NewAgencyUser()">New</button></div>
  </div>
  <div class="row">
    <div class="col-12">
      @if (agencyUsers && agencyUsers.length === 0) {
        <div class="text-center alert alert-info">There are no Users for the selected Agency. Click New to add one.</div>
      }
      @if (agencyUsers && agencyUsers.length > 0) {
        <table class="table table-striped table-responsive-md">
          <thead>
            <tr>
              <th scope="col">Name</th>
              <th scope="col">Email/Username</th>
              <th scope="col">Roles</th>
              <th scope="col">Login Allowed</th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            @for (agencyUser of agencyUsers; track agencyUser) {
              <tr>
                <td>{{ agencyUser.displayName }}</td>
                <td>{{ agencyUser.username }}</td>
                <td [innerHtml]="renderRoles(agencyUser.roles)"></td>
                <td>{{ renderAllowLoginUser(agencyUser.allowLogin, agencyUser.allowAppLogin) }}</td>
                <td ngbDropdown>
                  <button ngbDropdownToggle id="userActions">Actions</button>
                  <div ngbDropdownMenu aria-labelledby="userActions">
                    <button ngbDropdownItem (click)="AgencyUserDetails(agencyUser.username)"><i class="fa fa-pencil-square-o" style="width: 17px;"></i> Details</button>
                    <button ngbDropdownItem (click)="RemoveAgencyUser(agencyUser.id, agencyUser.username)"><i class="fa fa-times" style="width: 17px;"></i> Remove</button>
                    <button ngbDropdownItem (click)="ResetAgencyUserPassword(agencyUser.id)"><i class="fa fa-envelope-o" style="width: 17px;"></i> Send Password Reset Email</button>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      }
    </div>
  </div>
  <div class="row">
    <div class="table-caption col-10">Agency Security Administrators: @if (agencyAdminHelpMessage) {
      <i class="fa fa-question-circle" [ngbTooltip]="agencyAdminHelpMessage"></i>
    }</div>
    <div class="text-end col-2">@if (canManageAdmins) {
      <button (click)="NewAgencyAdmin()">New</button>
    }</div>
  </div>
  <div class="row">
    <div class="col-12">
      @if (agencyAdmins && agencyAdmins.length === 0) {
        <div class="text-center alert alert-info">There are no Security Administrators for the selected Agency. Click New to add one.</div>
      }
      @if (agencyAdmins && agencyAdmins.length > 0) {
        <table class="table table-striped table-responsive-sm">
          <thead>
            <tr>
              <th scope="col">Name</th>
              <th scope="col">Email/Username</th>
              <th scope="col">Login Allowed</th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            @for (agencyAdmin of agencyAdmins; track agencyAdmin) {
              <tr>
                <td>{{ agencyAdmin.displayName }}</td>
                <td>{{ agencyAdmin.username }}</td>
                <td>{{ renderAllowLoginAdmin(agencyAdmin.allowLogin) }}</td>
                <td ngbDropdown>
                  @if (canManageAdmins) {
                    <button ngbDropdownToggle id="adminActions">Actions</button>
                  }
                  <div ngbDropdownMenu aria-labelledby="userActions">
                    <button ngbDropdownItem (click)="AgencyAdminDetails(agencyAdmin.username)"><i class="fa fa-pencil-square-o" style="width: 17px;"></i> Details</button>
                    <button ngbDropdownItem (click)="RemoveAgencyAdmin(agencyAdmin.id, agencyAdmin.username)"><i class="fa fa-times" style="width: 17px;"></i> Remove</button>
                    <button ngbDropdownItem (click)="ResetAgencyAdminPassword(agencyAdmin.id)"><i class="fa fa-envelope-o" style="width: 17px;"></i> Send Password Reset Email</button>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      }
    </div>
  </div>
</form>
<app-user-detail #userDetail
  [isDuplicate]="isUserDuplicate"
  [isAlreadyAssigned]="isUserAlreadyAssigned"
  [accountAllowLoginHelpMessage]="accountAllowLoginHelpMessage"
  [applicationAllowLoginHelpMessage]="applicationAllowLoginHelpMessage"
  [showAppAllowLogin]="showAllowLogin"
  (result)="onUserUpdate($event)">
</app-user-detail>
<app-user-detail #adminDetail
  [isDuplicate]="isAdminDuplicate"
  [isAlreadyAssigned]="isAdminAlreadyAssigned"
  [accountAllowLoginHelpMessage]="accountAllowLoginHelpMessage"
(result)="onAdminUpdate($event)"></app-user-detail>
<app-confirmation #userConfirmDelete title="Delete Confirmation" (result)="onUserDeleteConfim($event)"></app-confirmation>
<app-confirmation #adminConfirmDelete title="Delete Confirmation" (result)="onAdminDeleteConfim($event)"></app-confirmation>
